/* ============================================================
   MID · SIATRA storefront — motion & interactions (vanilla)
   Resting state is VISIBLE. We only arm hide-then-reveal when JS
   runs and IntersectionObserver exists; otherwise content shows.
   ============================================================ */
(function () {
  "use strict";
  var docEl = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasIO = typeof IntersectionObserver !== "undefined";

  /* ---------- 1. Scroll reveal ---------- */
  var animOff = document.body.getAttribute("data-siatra-anim") === "false";
  if (hasIO && !reduce && !animOff) {
    docEl.classList.add("reveal-armed");
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); revealIO.unobserve(e.target); }
      });
    }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });

    var nodes = document.querySelectorAll("[data-reveal], .s-stagger");
    nodes.forEach(function (n) { revealIO.observe(n); });

    // Safety net: if anything is still hidden after 2.4s (IO never fired
    // for it — e.g. embedded/preview contexts), force-reveal it.
    setTimeout(function () {
      nodes.forEach(function (n) { n.classList.add("is-in"); });
    }, 2400);
  }

  /* ---------- 2. Header solidify ---------- */
  var hdr = document.getElementById("hdr");
  var fab = document.getElementById("fab");
  function onScrollChrome() {
    var y = window.pageYOffset || docEl.scrollTop;
    if (hdr) hdr.classList.toggle("is-solid", y > 40);
    if (fab) fab.classList.toggle("is-on", y > 520);
  }
  onScrollChrome();

  /* ---------- 3. Parallax (hero media) ---------- */
  var parallax = [].slice.call(document.querySelectorAll("[data-parallax]"));
  var ticking = false;
  function applyParallax() {
    var y = window.pageYOffset || docEl.scrollTop;
    parallax.forEach(function (el) {
      var speed = parseFloat(el.getAttribute("data-parallax")) || 0.15;
      el.style.transform = "translate3d(0," + (y * speed).toFixed(2) + "px,0)";
    });
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { window.requestAnimationFrame(function () { onScrollChrome(); if (!reduce) applyParallax(); }); ticking = true; }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  if (!reduce) applyParallax();

  /* ---------- 4. Services hover preview ---------- */
  var srvs = [].slice.call(document.querySelectorAll(".s-srv"));
  var imgs = [].slice.call(document.querySelectorAll(".s-srv-preview__img"));
  var cap = document.getElementById("srvCap");
  function activateSrv(i) {
    srvs.forEach(function (s, k) { s.classList.toggle("is-active", k === i); });
    imgs.forEach(function (im, k) { im.classList.toggle("is-active", k === i); });
    if (cap && srvs[i]) { var nm = srvs[i].querySelector(".s-srv__name"); if (nm) cap.textContent = nm.textContent; }
  }
  srvs.forEach(function (s, i) {
    s.addEventListener("mouseenter", function () { activateSrv(i); });
    s.addEventListener("focus", function () { activateSrv(i); });
  });

  /* ---------- 5. Testimonials slider ---------- */
  var TESTI = [];
  var testiDataEl = document.getElementById("testiData");
  if (testiDataEl) {
    try { TESTI = JSON.parse(testiDataEl.textContent) || []; } catch (e) { TESTI = []; }
  }
  var qEl = document.getElementById("testiQuote");
  var whoEl = document.getElementById("testiWho");
  var dotsEl = document.getElementById("testiDots");
  var tIndex = 0, tTimer = null;
  if (qEl && dotsEl) {
    TESTI.forEach(function (_, i) {
      var b = document.createElement("button");
      b.className = "s-testi__dot" + (i === 0 ? " is-on" : "");
      b.setAttribute("aria-label", "Testimonio " + (i + 1));
      b.addEventListener("click", function () { showTesti(i); resetTimer(); });
      dotsEl.appendChild(b);
    });
    function showTesti(i) {
      tIndex = i;
      var t = TESTI[i];
      qEl.style.opacity = 0; whoEl.style.opacity = 0;
      setTimeout(function () {
        qEl.textContent = "“" + t.q + "”";
        whoEl.innerHTML = "<b>" + t.n + "</b> · <span class='s-testi__role'>" + t.r + "</span>";
        qEl.style.transition = "opacity .6s var(--s-ease)"; whoEl.style.transition = "opacity .6s var(--s-ease)";
        qEl.style.opacity = 1; whoEl.style.opacity = 1;
      }, 280);
      [].slice.call(dotsEl.children).forEach(function (d, k) { d.classList.toggle("is-on", k === i); });
    }
    function resetTimer() { if (tTimer) clearInterval(tTimer); tTimer = setInterval(function () { showTesti((tIndex + 1) % TESTI.length); }, 5200); }
    resetTimer();
  }

  /* ---------- 6. Brands marquee (build track) ---------- */
  var brandTrack = document.getElementById("brandTrack");
  if (brandTrack && brandTrack.children.length > 0 && brandTrack.getAttribute("data-doubled") !== "1") {
    brandTrack.innerHTML = brandTrack.innerHTML + brandTrack.innerHTML; // duplicate for seamless loop
    brandTrack.setAttribute("data-doubled", "1");
  }

  /* ---------- 7. Mobile drawer ---------- */
  var drawer = document.getElementById("drawer");
  var burger = document.getElementById("burger");
  var drawerClose = document.getElementById("drawerClose");
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
  }
  if (burger) burger.addEventListener("click", function () { setDrawer(true); });
  if (drawerClose) drawerClose.addEventListener("click", function () { setDrawer(false); });
  if (drawer) {
    [].slice.call(drawer.querySelectorAll("a")).forEach(function (a) {
      a.addEventListener("click", function () { setDrawer(false); });
    });
  }

  /* ---------- 8. Smooth-scroll for in-page anchors (header offset) ---------- */
  [].slice.call(document.querySelectorAll('a[href^="#"]')).forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href");
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + (window.pageYOffset || docEl.scrollTop) - 70;
      window.scrollTo({ top: top, behavior: reduce ? "auto" : "smooth" });
    });
  });

  /* ---------- 9. Soft page transition (data-soft internal links) ---------- */
  [].slice.call(document.querySelectorAll("a[data-soft]")).forEach(function (a) {
    a.addEventListener("click", function (e) {
      var href = a.getAttribute("href");
      if (!href || href.charAt(0) === "#" || a.target === "_blank") return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let new-tab work
      e.preventDefault();
      if (reduce) { window.location.href = href; return; }
      document.body.classList.add("is-leaving");
      setTimeout(function () { window.location.href = href; }, 320);
    });
  });
})();
